import { SET_SMART_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const smartUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SMART_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default smartUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/SMART/reducer.js